import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { LaunchDialogService, LAUNCH_CALLER } from '@spartacus/storefront';
import {Observable, of, Subscription} from 'rxjs';
import { take } from 'rxjs/operators';
import {OrderDetailReorderComponent, OrderDetailsService} from "@spartacus/order/components";
import {RoutingService} from "@spartacus/core";

@Component({
  selector: 'cx-order-detail-reorder',
  templateUrl: './gonvarri-order-detail-reorder.component.html',
  styleUrl: './gonvarri-order-detail-reorder.component.scss',
  standalone: false
})
export class GonvarriOrderDetailReorderComponent extends OrderDetailReorderComponent implements OnInit, OnDestroy {

  override launchDialog(orderCode: string) {
    const dialog = this.launchDialogService.openDialog(
      "GONVARRI_REORDER",
      this.element,
      this.vcr,
      { orderCode }
    );

    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
  }

}
